export class StorageKey {
    static readonly AUTH_USER= 'authDetails';
    static readonly CURRENT_USER= 'currentUser';
    static readonly CURRENT_USER_AVATAR= 'currentUserAvatar';
}

export class AppSettings
{
    /** Hours from `now` for “how far in the past may a completed session still be edited” (−72 ⇒ 72h ago). */
    static readonly CANCEL_WINDOW = -72;
    static readonly REFUND_WINDOW = 24;

    /** Instant at the boundary: sessions starting **before** this are not editable from Past. */
    static pastSessionEditCutoffMs(): number {
        return Date.now() + AppSettings.CANCEL_WINDOW * 60 * 60 * 1000;
    }

    static parseSessionStartMs(item: any): number | null {
        if (item == null) {
            return null;
        }
        if (item.StartDateTime != null && String(item.StartDateTime).length) {
            const t = Date.parse(String(item.StartDateTime));
            if (!Number.isNaN(t)) {
                return t;
            }
        }
        const sd = item.StartDate;
        const st = item.StartTime;
        if (sd != null && st != null && String(st).length) {
            const date = new Date(sd);
            if (Number.isNaN(date.getTime())) {
                return null;
            }
            const ymd = date.toISOString().substring(0, 10);
            const t = Date.parse(`${ymd}T${String(st).trim()}`);
            if (!Number.isNaN(t)) {
                return t;
            }
        }
        return null;
    }

    /** Past / Completed row: allow edit only if session start is within the last 72 hours. */
    static isPastSessionEditable(item: any): boolean {
        const start = AppSettings.parseSessionStartMs(item);
        if (start == null) {
            return false;
        }
        return start >= AppSettings.pastSessionEditCutoffMs();
    }

};

